String.prototype.format = function (
  this: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>
): string {
  return this.replace(/\{([^}]+)\}/g, (match, path) => {
    let currentObject = values;
    for (const segment of path.split('.')) {
      if (segment in currentObject) {
        currentObject = currentObject[segment];
      } else {
        return match; // マッチしない場合は元のテキストをそのまま返す
      }
    }
    return String(currentObject); // 常に文字列を返す
  });
};
